var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.3682C17.7517 22.3682 22.3682 17.7984 22.3682 12.0467C22.3682 6.29492 17.7517 1.63184 12 1.63184M12 22.3682C6.24826 22.3682 1.63184 17.7984 1.63184 12.0467C1.63184 6.29492 6.24826 1.63184 12 1.63184M12 22.3682C14.3993 22.3682 15.8697 19.3027 16.4185 15.529M12 22.3682C9.60073 22.3682 8.13033 19.3027 7.58146 15.529M12 1.63184C14.3952 1.63184 15.8711 4.72978 16.4202 8.53084M12 1.63184C9.60476 1.63184 8.12887 4.72978 7.57981 8.53084M2.92786 8.53084H7.57981M7.57981 8.53084H16.4202M7.57981 8.53084C7.25453 10.7828 7.25456 13.2815 7.58146 15.529M16.4202 8.53084H21.0721M16.4202 8.53084C16.7455 10.7828 16.7454 13.2815 16.4185 15.529M2.92786 15.529H7.58146M7.58146 15.529H16.4185M16.4185 15.529H21.0721",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebLine);
export default __webpack_public_path__ + "static/media/web_line.85ad1fe6cfd7844a367281a4ece49748.svg";
export { ForwardRef as ReactComponent };